<div class="section-header d-flex align-items-center px-3 pb-2 pt-1 no-user-select">
    <span class="back-arrow me-2" (click)="goBack()">&#8592;</span>
    <h5 class="mb-0 section-title">{{ title }}</h5>
</div>